import { Directive, HostListener, Input, Optional } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validatePrevious]'
})
export class ValidatePreviousDirective {
  @Input('validatePrevious') controlName!: string;
  @Input() validatePreviousOrder!: string[];

  constructor(
    private controlContainer: ControlContainer,
    @Optional() private rootFormGroup: FormGroupDirective
  ) {}

  private getForm(): FormGroup | null {
    const local = this.controlContainer && (this.controlContainer.control as FormGroup | null);
    if (local) return local;
    if (this.rootFormGroup) return this.rootFormGroup.control as FormGroup;
    return null;
  }

  private resolveControl(form: FormGroup | null, name: string): AbstractControl | null {
    if (!form) return null;
    let ctrl: AbstractControl | null = form.get(name) ?? null;
    if (!ctrl && this.rootFormGroup) {
      ctrl = this.rootFormGroup.control.get(name) ?? null;
    }
    return ctrl;
  }

  private markPreviousInvalidTouched() {
    const form = this.getForm();
    if (!form || !this.validatePreviousOrder || !this.controlName) return;
    const idx = this.validatePreviousOrder.indexOf(this.controlName);
    if (idx < 0) return;
    for (let i = 0; i <= idx; i++) {
      const name = this.validatePreviousOrder[i];
      const ctrl = this.resolveControl(form, name);
      if (ctrl && ctrl.invalid && !ctrl.touched) {
        ctrl.markAsTouched();
      }
    }
  }

  @HostListener('focusin')
  onFocusIn() {
    this.markPreviousInvalidTouched();
  }

  @HostListener('mousedown')
  onMouseDown() {
    this.markPreviousInvalidTouched();
  }
}